export default {"src":"/pro/_next/static/media/blitz-brand-icon.03704416.svg","height":203,"width":179,"blurWidth":0,"blurHeight":0};